import React, { Component } from "react";

export default class GroupedDropDownCellRenderer extends Component {
  render() {
    return <div></div>;
  }
}
